import React from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  PinInput,
  PinInputField,
} from '@chakra-ui/react';
import { DEFAULT_CAREGIVER_PIN_LENGTH } from '../../constants/caregiverPin';

interface AleaPinProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  length?: number;
  isDisabled?: boolean;
  isRequired?: boolean;
  labelFontWeight?: number;
  error?: string;
}

const AleaPin: React.FC<AleaPinProps> = ({
  label,
  value,
  onChange,
  length = DEFAULT_CAREGIVER_PIN_LENGTH,
  isDisabled,
  isRequired,
  labelFontWeight,
  error,
}) => {
  const formLabelStyles = {
    fontWeight: labelFontWeight ?? (isRequired ? 500 : 300),
    marginBottom: '6px',
    color: 'alea.500',
    paddingLeft: 0,
    textAlign: 'left',
  };

  return (
    <FormControl isInvalid={!!error}>
      <FormLabel sx={formLabelStyles}>{label}</FormLabel>

      <PinInput value={value} onChange={onChange} otp type="number" isDisabled={isDisabled}>
        <HStack spacing="5px" flexWrap="nowrap" borderRadius="15px">
          {Array.from({ length }).map((_, idx) => (
            <PinInputField
              // eslint-disable-next-line react/no-array-index-key
              key={idx}
              bg="#fff"
              w="40px"
              h="50px"
              borderRadius="15px"
              border="1px solid"
              borderColor="#DCDCDC"
              color="#000"
              fontSize="18px"
              fontWeight={400}
              textAlign="center"
              _focus={{ borderColor: 'alea.500', boxShadow: 'none', outline: 'none' }}
              _focusVisible={{
                borderColor: 'alea.500',
                outline: '0px solid',
                outlineColor: 'alea.500',
                outlineOffset: '1px',
              }}
            />
          ))}
        </HStack>
      </PinInput>

      {error && (
        <FormErrorMessage mt="6px" color="invalid.500" fontSize="15px" fontWeight={300}>
          {error}
        </FormErrorMessage>
      )}
    </FormControl>
  );
};

export default AleaPin;


